module.exports = __webpack_public_path__ + "img/78.e23e9741.jpg";